import z from 'zod'
import { HotelShoppingFilterSchema } from '@reward-platform/ancillaries-schemas/hotel'
import { DEFAULT_RECOMMENDED_SORTING } from '@reward-platform/ancillaries-schemas/common'
import {
  DestinationParamsSchema,
  DateRangeParamsSchema,
  PaginationParamsSchema,
  SortingParamsSchema,
} from './commonResults'

export const HotelSearchBrowserParamsSchema = z
  .object({
    occupancy: z.string().optional(),
    rooms: z.string().optional(), // backwards compat: accept old URLs that used rooms=
  })
  .and(DestinationParamsSchema)
  .and(DateRangeParamsSchema)

export type HotelSearchBrowserParams = z.infer<typeof HotelSearchBrowserParamsSchema>

// TODO: implement and flatten this for results pages
export const HotelSearchResultsBrowserParamsSchema = z
  .object({
    // Should create flattened schema here for shopping filters and sorting to remove nesting
    shoppingFilter: HotelShoppingFilterSchema.optional(),
    sorting: SortingParamsSchema.default(DEFAULT_RECOMMENDED_SORTING),
  })
  .and(HotelSearchBrowserParamsSchema)
  .and(PaginationParamsSchema)

export type HotelSearchResultsBrowserParams = z.infer<typeof HotelSearchResultsBrowserParamsSchema>
